/**
 * ============================================================================
 *  LES PHOTOS A LA BONNE TAILLE (13/10/2026)
 * ============================================================================
 *
 *  Les photos des articles viennent du serveur d'images de Glovo
 *  (glovo.dhmedia.io, images.deliveryhero.io). Telechargees telles quelles,
 *  elles pesaient en moyenne 570 Ko — jusqu'a 3 Mo — pour une vignette de
 *  quelques centimetres : une page de 30 articles faisait ~17 Mo.
 *
 *  Ce serveur sait redimensionner a la demande (`?width=`). Mesure sur 30
 *  photos : 400 px -> 3 fois plus leger, 160 px -> encore bien moins. Rien
 *  n'est stocke chez nous ; une adresse d'un autre serveur (preuve photo,
 *  emballage) repart telle quelle.
 * ============================================================================
 */
const HOTES_GLOVO = new Set(["glovo.dhmedia.io", "images.deliveryhero.io"]);

/** L'adresse de la photo, reduite a `largeur` pixels si le serveur le permet. */
export function photoReduite(url: unknown, largeur = 400): string {
  const brut = String(url || "");
  if (!brut) return "";
  try {
    const u = new URL(brut);
    if (!HOTES_GLOVO.has(u.hostname) || u.searchParams.has("width")) return brut;
    u.searchParams.set("width", String(largeur));
    return u.toString();
  } catch {
    return brut;
  }
}
